import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { formSubmitWithWaitForJobCompletion } from "../../../../scripts/jobCompletion";
import { selectize, getScoreFunctionPreservingOrderInSearch } from "../../../../scripts/selectizeHelper";

export default class CreateOrEditController extends Controller {
    static targets = [
        "form",
        "submit",
        "language",
    ];

    static values = {
        getJobUrl: String
    };

    readonly formTarget!: HTMLElement;
    readonly submitTarget!: HTMLElement;
    readonly languageTarget!: HTMLElement;

    readonly getJobUrlValue!: string;

    connect() {
        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitTarget),
            this.getJobUrlValue,
            () => {
                Turbo.clearCache();
                history.back();
            }
        );

        selectize($(this.languageTarget), {
            score: getScoreFunctionPreservingOrderInSearch
        });
    }
}
